// Arquivo de redefinição de senha
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../../../services/api';
import { ThemeProvider } from 'styled-components';
import { lightTheme } from '../../../themes/light';
import { GlobalStyles } from '../../../globals';
import {
  Container,
  FormContainer,
  FormGroup,
  Label,
  Input,
  SubmitButton,
  ErrorMessage,
  SuccessMessage,
  Title,
  ContentWrapper
} from './styles';
import Loading from '../../../components/Loading';

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  
  // Usando o tema light diretamente, sem verificar o localStorage
  const theme = lightTheme;

  // Simulação de carregamento inicial da página
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validações
    if (!password || !confirmPassword) {
      setError('Fill in all fields');
      return;
    }
    
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }
    
    setError('');
    setSuccess('');
    setIsLoading(true);
    
    try {
      // Usando o token da URL para reset de senha
      const requestData = {
        newPassword: password,
        confirmPassword: confirmPassword
      };
      
      // Usando o endpoint fornecido
      await api.post(`/api/auth/reset-password/${token}`, requestData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      // Limpa os campos e mostra mensagem de sucesso
      setPassword('');
      setConfirmPassword('');
      setSuccess('Password changed successfully! Redirecting to login...');
      
      // Redirecionar para a página de login após 3 segundos
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      console.error('Error changing password:', error);
      setError('Error processing your request. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme as any}>
      <GlobalStyles />
      {isPageLoading && <Loading fullScreen />}
      {isLoading && <Loading />}
      
      <Container>
        <ContentWrapper>
          {!isPageLoading && (
            <FormContainer>
              <Title>Reset Password</Title>
              
              <form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label>New password</Label>
                  <Input 
                    type="password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    placeholder="********"
                  />
                </FormGroup>
                
                <FormGroup>
                  <Label>Confirm new password</Label>
                  <Input 
                    type="password" 
                    value={confirmPassword} 
                    onChange={(e) => setConfirmPassword(e.target.value)} 
                    placeholder="********"
                  />
                </FormGroup>
                
                {error && <ErrorMessage>{error}</ErrorMessage>}
                {success && <SuccessMessage>{success}</SuccessMessage>}
                
                <div style={{ marginTop: '20px' }}>
                  <SubmitButton type="submit" disabled={isLoading} style={{ width: '100%' }}>
                    Change Password
                  </SubmitButton>
                </div>
              </form>
            </FormContainer>
          )}
        </ContentWrapper>
      </Container>
    </ThemeProvider>
  );
};

export default ResetPassword;
